/** Nome da view no PostgREST (uso interno nas queries; não exibir na UI). */
export const VW_ORCAMENTO_V2 = 'solis_vw_orcamento_por_subtipo_centro_com_chave_v2' as const

export type OrcamentoV2Linha = {
  ano: number
  centro_resultado: string | null
  tipo_receita_despesa: string | null
  classificacao_receita_despesa: string | null
  subtipo_despesa: string | null
  centro_custo_id: string | null
  tipo_despesa_id: string | null
  centro_custo_pipefy_id: string | null
  tipo_despesa_pipefy_id: string | null
  chave_unica_v2: string | null
  tipo_despesa_n1_pipefy_id: string | null
  tipo_despesa_n2_pipefy_id: string | null
  tipo_despesa_n3_pipefy_id: string | null
  valor_total_orcado: number | string | null
  quantidade_registros: number | null
  valor_minimo: number | string | null
  valor_maximo: number | string | null
  valor_medio: number | string | null
  valor_movimentado_saida: number | string | null
  valor_movimentado_entrada: number | string | null
  valor_contratado: number | string | null
  valor_pago: number | string | null
  valor_contratado_pendente: number | string | null
  valor_comprometido: number | string | null
  valor_verba_adicional: number | string | null
  valor_saldo_disponivel: number | string | null
  valor_sobra: number | string | null
}

export function num(v: unknown): number {
  if (v === null || v === undefined) return 0
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

/** % uso do orçado pelo comprometido (0–1+). */
export function percentUsoOrcado(row: Pick<OrcamentoV2Linha, 'valor_total_orcado' | 'valor_comprometido'>): number {
  const o = num(row.valor_total_orcado)
  if (o <= 0) return 0
  return num(row.valor_comprometido) / o
}
